'use client'

import {useEffect, useState} from 'react'

const hasVisualViewport = (visualViewport: VisualViewport | null | undefined): visualViewport is VisualViewport => {
  return visualViewport !== undefined && visualViewport !== null
}

/** Возвращает всегда актуальный размер видимой области, с учетом виртуальной клавиатуры на мобилке, адресной строки и всего-всего-всего. Если VisualViewport не поддерживается - фолбечится на innerWidth, innerHeight */
export const useViewportSize = () => {
  const [{width, height}, setVisualViewport] = useState(() =>
    hasVisualViewport(window.visualViewport)
      ? {
          width: window.visualViewport.width ?? 0,
          height: window.visualViewport.height ?? 0,
        }
      : {width: window.innerWidth, height: window.innerHeight},
  )

  useEffect(() => {
    const update = () => {
      if (!hasVisualViewport(window.visualViewport)) {
        return
      }

      setVisualViewport({width: window.visualViewport?.width, height: window.visualViewport?.height})
    }

    window.visualViewport?.addEventListener('resize', update)
    return () => {
      window.visualViewport?.removeEventListener('resize', update)
    }
  }, [])

  return {width: width, height: height}
}
